import { useEffect, useState } from "react";
import { toast } from "sonner";
import { XLogo, LinkedinLogo, WhatsappLogo, FacebookLogo, TelegramLogo, LinkSimple, EnvelopeSimple } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";

export const useTitle = (title) => {
  useEffect(() => {
    if (title) document.title = `${title} · HackLabs`;
  }, [title]);
};

export const ShareBar = ({ title }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const t = encodeURIComponent(`${title} — en HackLabs`);
  const u = encodeURIComponent(url);
  const links = [
    ["x", XLogo, `https://twitter.com/intent/tweet?text=${t}&url=${u}`],
    ["linkedin", LinkedinLogo, `https://www.linkedin.com/sharing/share-offsite/?url=${u}`],
    ["whatsapp", WhatsappLogo, `https://wa.me/?text=${t}%20${u}`],
    ["telegram", TelegramLogo, `https://t.me/share/url?url=${u}&text=${t}`],
    ["facebook", FacebookLogo, `https://www.facebook.com/sharer/sharer.php?u=${u}`],
  ];
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Enlace copiado"); };
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid="share-bar">
      <span className="mr-2 text-[11px] uppercase tracking-widest text-zinc-500">Compartir</span>
      {links.map(([id, I, href]) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" className="grid h-9 w-9 place-items-center border border-white/10 text-zinc-400 hover:border-white/30 hover:text-white" data-testid={`share-${id}`} style={{ transition: "color 160ms, border-color 160ms" }}><I size={16} /></a>
      ))}
      <button onClick={copy} className="grid h-9 w-9 place-items-center border border-white/10 text-zinc-400 hover:border-white/30 hover:text-white" data-testid="share-copy"><LinkSimple size={16} /></button>
    </div>
  );
};

export const NewsletterBox = ({ source = "landing", compact = false }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/subscribe", { email, source });
      setDone(true);
      toast.success("¡Suscrito! Te avisaremos de cada lanzamiento.");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className={`panel relative overflow-hidden ${compact ? "p-6" : "p-8 md:p-10"}`} data-testid={`newsletter-${source}`}>
      <div className="grid-bg absolute inset-0 opacity-40" />
      <div className="relative grid gap-6 md:grid-cols-2 md:items-end">
        <div>
          <EnvelopeSimple size={24} weight="duotone" className="text-cyan-400" />
          <h3 className="mt-4 font-display text-2xl font-bold tracking-tight sm:text-3xl">Sé el primero en enterarte.</h3>
          <p className="mt-2 text-sm text-zinc-400">Nuevos agentes, modelos locales y software de HackLabs. Ofertas de lanzamiento exclusivas para suscriptores.</p>
        </div>
        {done ? (
          <p className="font-mono text-sm text-emerald-400" data-testid="newsletter-success">✓ Suscripción confirmada</p>
        ) : (
          <form onSubmit={submit} className="flex gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" className="field !py-3" data-testid="newsletter-email-input" />
            <button className="btn-primary shrink-0 !py-3" data-testid="newsletter-submit-button">Suscribirme</button>
          </form>
        )}
      </div>
    </div>
  );
};
